import { PriorityType, TenureType, UrgencyType } from '@graphql/requests';

export const preferenceOptions = {
  urgency: [
    { label: 'Now', value: UrgencyType.Now },
    { label: 'In the next few weeks', value: UrgencyType.Soon },
    { label: 'I’m just Browsing', value: UrgencyType.JustBrowsing },
  ],
  priority: [
    { label: 'Service', value: PriorityType.Service },
    { label: 'Price', value: PriorityType.Price },
    { label: 'Speed', value: PriorityType.Speed },
  ],
};
export const purchaseOptions = {
  tenure: [
    { label: 'Freehold (House)', value: TenureType.Freehold },
    { label: 'Leasehold (Flat)', value: TenureType.Leasehold },
    { label: 'Shared Ownership', value: TenureType.SharedOwnership },
    { label: 'Other', value: TenureType.Unknown },
  ],
  mortgage: [
    {
      label: 'No',
      value: false,
    },
    {
      label: 'Yes',
      value: true,
    },
  ],
  additionalDetails: [
    {
      label: 'Ownership',
      options: [
        { label: 'First Time Buyer', value: 'firstTimeBuyer' },
        { label: 'Second Home', value: 'secondHome' },
      ],
    },
    {
      label: 'Finance',
      options: [
        { label: 'Gifted Deposit', value: 'gift' },
        { label: 'Help to Buy', value: 'helpToBuy' },
        { label: 'Buy to Let Mortgage', value: 'buyToLet' },
      ],
    },
    {
      label: 'Property',
      options: [{ label: 'New Build', value: 'newBuild' }],
    },
  ],
};
export const sellerOptions = {
  mortgage: [
    {
      label: 'No',
      value: false,
    },
    {
      label: 'Yes',
      value: true,
    },
  ],
  additionalDetails: [
    {
      label: 'Shared Ownership',
      options: [
        { label: 'Housing Association', value: 'housingAssociation' },
        { label: 'Help to Buy', value: 'helpToBuy' },
      ],
    },
  ],
};
